import React, { createRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Transition } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const TransitionDropdownItem = ({
    item,
    lang,
    navigate,
    toggleMainMenu,
    depth = 0,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasSubMenu = item?.sub_menu?.length > 0;

    if (hasSubMenu) {
        return (
            <div className={`${depth > 0 ? 'pl-4' : ''}`}>
                <button
                    className="flex w-full flex-row items-center justify-between p-[10px] text-left"
                    onClick={() => setIsOpen((prev) => !prev)}
                    type="button"
                >
                    <div>{lang === "en" ? (item?.title_en ? item?.title_en : item?.title) : item?.title}</div>
                    <div>
                        <FontAwesomeIcon icon={faChevronDown} color="primary" className={`${isOpen ? 'rotate-180' : ''} transition-transform`} />
                    </div>
                </button>
                {isOpen && item?.sub_menu?.map((submenu, index) => (
                    <TransitionDropdownItem
                        key={`${submenu?.path || submenu?.title}-${index}`}
                        item={submenu}
                        lang={lang}
                        navigate={navigate}
                        toggleMainMenu={toggleMainMenu}
                        depth={depth + 1}
                    />
                ))}
            </div>
        );
    }

    return (
        <div
            className={`p-[10px] ${depth > 0 ? 'pl-8' : ''}`}
            onClick={() => {
                item?.path && navigate(item?.path);
                toggleMainMenu();
            }}
        >
            {lang === "en" ? (item?.title_en ? item?.title_en : item?.title) : item?.title}
        </div>
    );
};

const TransitionDropdown = ({
    title = "",
    title_en = "",
    items = [],
    withChevron = false,
    colorChevron = "primary",
    toggleMainMenu
}) => {
    const lang = localStorage.getItem('i18nextLng');
    const [isOpen, setIsOpen] = useState(false);
    let navigate = useNavigate();
    const ref = createRef();
    const toggleIsOpen = () => {
        setIsOpen(prev => !prev)
    }
    return (
        <>
            <button
                onClick={toggleIsOpen}
                className='flex flex-row font-semibold p-[10px]'
            >
                <div className='mr-2'>{lang === "en" ? (title_en ? title_en : title) : title}</div>
                {items.length > 0 && withChevron && <div><FontAwesomeIcon icon={faChevronDown} color={colorChevron} /></div>}
            </button>
            {
                items.length > 0 && (
                    <Transition
                        ref={ref}
                        show={isOpen}
                        enter="transition ease-out duration-100 transform"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-75 transform"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        {
                            (ref) => {
                                return (
                                    <>
                                        <div className="flex flex-wrap flex-col p-[10px] font-semibold">
                                            {items?.map((val, ind) => (
                                                <TransitionDropdownItem
                                                    key={`${val?.path || val?.title}-${ind}`}
                                                    item={val}
                                                    lang={lang}
                                                    navigate={navigate}
                                                    toggleMainMenu={toggleMainMenu}
                                                />
                                            ))}
                                        </div>
                                    </>
                                )
                            }
                        }
                    </Transition>
                )
            }
        </>
    )
}
export default TransitionDropdown;
